import { COMPARISON_OPERATOR, CRITERIA } from 'modules/push-api/utils/subscriptionConsts';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { AndOrToggle } from '../AndOrToggle/AndOrToggle';
import { ComparisonOperatorDropdown } from '../ComparisonOperatorDropdown/ComparisonOperatorDropdown';
import { CriteriaDropdown } from '../CriteriaDropdown/CriteriaDropdown';
import { FieldNameDropdown } from '../FieldNameDropdown/FieldNameDropdown';
import { ValueCriterionInputField } from '../ValueCriterionInputField/ValueCriterionInputField';
import styles from './subscriptionFilter.module.scss';

const newComparisonOperatorField = 'newComparisonOperatorCriterion';
const previousComparisonOperatorField = 'previousComparisonOperatorCriterion';

export const SubscriptionFilter = ({ itemKey, fieldIndex, entityIndex, filterIndex }) => {
    const { value: newComparisonOperator } = useFormFieldValue({
        field: newComparisonOperatorField,
    });

    const { value: previousComparisonOperator } = useFormFieldValue({
        field: previousComparisonOperatorField,
    });

    const shouldShowNewValueInput =
        newComparisonOperator === COMPARISON_OPERATOR.REGEX || newComparisonOperator === COMPARISON_OPERATOR.EQUALS_TO;

    const shouldShowPreviousValueInput =
        previousComparisonOperator === COMPARISON_OPERATOR.REGEX ||
        previousComparisonOperator === COMPARISON_OPERATOR.EQUALS_TO;

    return (
        <div className={styles['columns']}>
            <div className={styles['rows']}>
                <FieldNameDropdown fieldIndex={fieldIndex} entityIndex={entityIndex} filterIndex={filterIndex} />
                <CriteriaDropdown selectedCriteria={CRITERIA.NEW_VALUE_CRITERIA} />
                <ComparisonOperatorDropdown selectedComparisonOperator={newComparisonOperatorField} />
                <div className={styles['value-field-container']}>
                    {shouldShowNewValueInput && <ValueCriterionInputField selectedValueCriterion="newValueCriterion" />}
                </div>
            </div>
            <div className={styles['rows']}>
                <div className={styles['toggle-container']}>
                    <AndOrToggle />
                </div>
                <FieldNameDropdown
                    fieldIndex={fieldIndex}
                    entityIndex={entityIndex}
                    filterIndex={filterIndex}
                    disabled={true}
                    isNewFilter={true}
                />
                <CriteriaDropdown selectedCriteria={CRITERIA.OLD_VALUE_CRITERIA} />
                <ComparisonOperatorDropdown selectedComparisonOperator={previousComparisonOperatorField} />
                <div className={styles['value-field-container']}>
                    {shouldShowPreviousValueInput && (
                        <ValueCriterionInputField selectedValueCriterion="previousValueCriterion" />
                    )}
                </div>
            </div>
        </div>
    );
};
